module.exports = __webpack_public_path__ + "static/media/bib.4c1089cc.jpg";